export default __webpack_public_path__ + "static/media/help.fec0c3e8.png";